import { Navigate } from "react-router-dom";

const Navigation = {
  navigateToLogin() {
    return <Navigate to={`/login`} />;
  },
  navigateToHome() {
    return <Navigate to={"/"} />;
  },
};

export default Navigation;
